import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { DataRecency } from "src/types"
import { serverInsulinToUserInsulin } from "src/utils"

export function isCartridgeFillLow(
  cartridgeFill: PumpStatus["cartridge_fill"],
  pumpStatusRecency: DataRecency,
) {
  return (
    cartridgeFill !== null &&
    serverInsulinToUserInsulin(cartridgeFill) <= 20 &&
    pumpStatusRecency !== DataRecency.Stale
  )
}
